import cmService from "~/service/mksCmService";

import get from "lodash/get";

export default {
  data() {
    return { article: null, key: 1 };
  },
  computed: {
    breadcrumb() {
      let pathArray = this.$route.path.split("/");
      pathArray.shift();
      const breadCrumbs = [{ to: "/", text: "Homepage" }];
      // needed to handle the intermediary entries for nested vue routes
      let breadcrumb = "";
      // let lastIndexFound = 0;

      for (let i = 0; i < pathArray.length; ++i) {
        breadcrumb = `${breadcrumb}${"/"}${pathArray[i]}`;
        if (
          this.$route.matched[i] &&
          Object.hasOwnProperty.call(this.$route.matched[i], "meta") &&
          Object.hasOwnProperty.call(this.$route.matched[i].meta, "breadCrumb")
        ) {
          breadCrumbs.push({
            href: breadcrumb,
            // i !== 0 && pathArray[i - (i - lastIndexFound)]
            //   ? "/" + pathArray[i - (i - lastIndexFound)] + breadcrumb
            //   : breadcrumb,
            exact: false,
            disabled: i + 1 === pathArray.length,
            text: this.$route.matched[i].meta.breadCrumb || pathArray[i]
          });
          // lastIndexFound = i;
          // breadcrumb = "";
        } else if (i == pathArray.length - 1) {
          if (this.article) {
            breadCrumbs.push({
              link: true,
              text: this.article.title,
              to: { name: "Page", slug: this.article.slug }
            });
          }
        }
      }
      return breadCrumbs;
    }
  },
  methods: {
    async reload(slug) {
      if (slug && slug.length > 0) {
        let data = await cmService.getArticle({ slug: slug });
        this.article = data.data;
        this.key++;
      }
    }
  },
  created() {
    this.article = this.$route.params.article;
  },
  jsonld() {
    if (this.article) {
      return {
        "@context": "https://schema.org",
        "@type": "NewsArticle",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": this.article.link
        },
        headline: this.article.meta ? this.article.meta.seo_title : "",
        image: ["/logo/social-logo.png"],
        author: {
          "@type": "Organization",
          name: global.config?.defaultPageName
        },
        datePublished: this.article.date,
        dateModified: this.article.date,
        publisher: {
          "@type": "Organization",
          name: global.config?.defaultPageName,
          logo: {
            "@type": "ImageObject",
            url: "/logo/social-logo.png"
          }
        }
      };
    }
  },
  metaInfo() {
    if (this.article) {
      return {
        title: get(this.article, "meta.seo_title"),
        link: [
          {
            rel: "canonical",
            href: `https://${window.location.host}/page/${this.article.slug}`
          }
        ],
        meta: [
          {
            vmid: "description",
            name: "description",
            content: get(this.article, "meta.seo_description")
          },
          // Open Graph Metas

          {
            vmid: "og:title",
            property: "og:title",
            content: get(
              this.article,
              "meta.seo_title",
              global.config?.defaultPageName
            )
          },
          {
            vmid: "og:type",
            property: "og:type",
            content: "website"
          },
          {
            vmid: "og:url",
            property: "og:url",
            content: location.href
          },
          {
            vmid: "og:image",
            property: "og:image",
            content:
              "https://" + window.location.host + global.config.socialLogo ||
              "/logo/social-logo.png"
          },
          {
            vmid: "og:image:alt",
            property: "og:image:alt",
            content: get(this.article, "meta.seo_description")
          },
          {
            vmid: "og:site_name",
            property: "og:site_name",
            content: global.config?.defaultPageName
          },
          // Twitter Metas
          {
            name: "twitter:card",
            content: "summary_large_image"
          },
          {
            name: "twitter:title",
            content: get(this.article, "meta.seo_title", "Pagina statica")
          },
          {
            name: "twitter:image",
            content:
              "https://" + window.location.host + global.config.socialLogo ||
              "/logo/social-logo.png"
          },
          {
            name: "twitter:url",
            content: location.href
          }
        ]
      };
    }
  }
};
